import { GenericError } from '@psyomics/ui-components';
import { useLocation, useParams } from 'react-router-dom';

import { Survey as SurveyFeature } from '../../../features/survey/survey';

const reviewPattern = /\/questionnaire\/.*\/review/;
const Questionnaire = () => {
  const { id: invitePublicId } = useParams();
  const { pathname } = useLocation();
  const isReview = reviewPattern.test(pathname);
  if (!invitePublicId) {
    return <GenericError />;
  }
  return <SurveyFeature invitePublicId={invitePublicId} reviewMode={isReview} />;
};

export default Questionnaire;
